import { CSSProperties } from 'react'

const ProductPoints: React.FC<{
  points: number
  description?: string
  containerStyle?: CSSProperties
  separatorStyle?: CSSProperties
  pointsStyle?: CSSProperties
  descriptionStyle?: CSSProperties
}> = ({ points, description = 'Points', containerStyle, separatorStyle, pointsStyle, descriptionStyle }) => {
  return (
    <span data-testid="product-tile-points-container" style={containerStyle}>
      <span style={separatorStyle} data-testid="product-tile-points-separator">
        |
      </span>{' '}
      <span style={pointsStyle} data-testid="product-tile-points">
        {points.toLocaleString('en-AU')}
      </span>{' '}
      <span style={descriptionStyle} data-testid="product-tile-points-description">
        {description}
      </span>
    </span>
  )
}

export default ProductPoints
